import { createContext } from 'react';

import { PageId } from '../../apis';

export interface PageViewContextValue {
  pageId: PageId | null;
  pageViewId: string | null;
}

export const PageViewContext = createContext<PageViewContextValue>({
  pageId: null,
  pageViewId: null,
});
